/* ABRO flipbook catalog – wraps StPageFlip (assets/page-flip.browser.js) with a reader UI. */
(function () {
  'use strict';

  function initFlipbook(root) {
    if (!root || root.dataset.fbInit) return;
    root.dataset.fbInit = '1';

    var section = root.closest('.abro-fb-page') || root;
    var book = root.querySelector('[data-fb-book]');
    var shell = root.querySelector('.abro-fb__shell');
    var pagesEls = Array.prototype.slice.call(book.querySelectorAll('.abro-fb__page'));
    var count = pagesEls.length;
    var input = root.querySelector('[data-fb-input]');
    var live = root.querySelector('[data-fb-live]');
    var toast = root.querySelector('[data-fb-toast]');
    var zoomDlg = root.querySelector('.abro-fb__zoom');
    var zoomPages = root.querySelector('[data-fb-zoom-pages]');
    var zoomScroll = root.querySelector('[data-fb-zoom-scroll]');
    var zoomLabel = root.querySelector('[data-fb-zoom-level]');
    var pageFlip = null;
    var current = 0;
    var userMoved = false;

    function $all(sel, scope) { return Array.prototype.slice.call((scope || root).querySelectorAll(sel)); }
    function imgOf(i) { return pagesEls[i] && pagesEls[i].querySelector('img'); }

    /* Lazy-load page images around the current spread so flips never show blanks */
    function loadAround(i) {
      for (var j = i - 2; j <= i + 4; j++) {
        var img = imgOf(j);
        if (img && img.dataset.src) {
          img.srcset = img.dataset.srcset;
          img.src = img.dataset.src;
          delete img.dataset.src;
          delete img.dataset.srcset;
        }
      }
    }

    function isPortrait() { return !pageFlip || pageFlip.getOrientation() === 'portrait'; }
    function visiblePages(i) {
      if (isPortrait() || i === 0) return [i];
      var left = i % 2 === 1 ? i : i - 1;
      return [left, left + 1].filter(function (p) { return p < count; });
    }

    function showToast(msg) {
      toast.textContent = msg;
      toast.hidden = false;
      clearTimeout(showToast.t);
      showToast.t = setTimeout(function () { toast.hidden = true; }, 2200);
    }

    function updateUI() {
      var vis = visiblePages(current);
      var first = vis[0] + 1;
      var last = vis[vis.length - 1] + 1;
      if (document.activeElement !== input) input.value = first;
      live.textContent = first === last ? 'Page ' + first + ' of ' + count : 'Pages ' + first + ' and ' + last + ' of ' + count;
      var atStart = vis[0] === 0;
      var atEnd = vis[vis.length - 1] >= count - 1;
      $all('[data-fb="prev"],[data-fb="first"]').forEach(function (b) { b.disabled = atStart; });
      $all('[data-fb="next"],[data-fb="last"]').forEach(function (b) { b.disabled = atEnd; });
      $all('.abro-fb__thumbs button').forEach(function (b, idx) { b.classList.toggle('is-current', vis.indexOf(idx) !== -1); });
      if (userMoved && history.replaceState) history.replaceState(null, '', first === 1 ? location.pathname + location.search : '#page-' + first);
    }

    function goTo(n) {
      var i = Math.max(0, Math.min(count - 1, n));
      userMoved = true;
      if (root.classList.contains('is-scroll')) {
        var target = root.querySelectorAll('.abro-fb__scroll img')[i];
        if (target) target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        return;
      }
      if (!pageFlip) return;
      loadAround(i);
      if (visiblePages(current).indexOf(i) !== -1) return;
      if (Math.abs(i - current) <= 2) pageFlip.flip(i); else pageFlip.turnToPage(i);
      current = pageFlip.getCurrentPageIndex();
      loadAround(current);
      updateUI();
    }

    /* Book */
    function startBook() {
      var hash = (location.hash.match(/^#page-(\d+)$/) || [])[1];
      var start = hash ? Math.max(0, Math.min(count - 1, parseInt(hash, 10) - 1)) : 0;
      loadAround(start);
      pageFlip = new window.St.PageFlip(book, {
        width: 612, height: 792, size: 'stretch',
        minWidth: 260, maxWidth: 1000, minHeight: 336, maxHeight: 1294,
        showCover: true, usePortrait: true, mobileScrollSupport: true,
        maxShadowOpacity: 0.45, flippingTime: 650, startPage: start, autoSize: true
      });
      pageFlip.loadFromHTML(pagesEls);
      book.classList.add('is-ready');
      current = pageFlip.getCurrentPageIndex();
      var ready = false;
      setTimeout(function () { ready = true; }, 400); // StPageFlip fires 'flip' during init; only later flips are the reader's
      pageFlip.on('flip', function (e) { current = e.data; if (ready) userMoved = true; loadAround(current); updateUI(); });
      pageFlip.on('changeOrientation', function () { updateUI(); });
      updateUI();
    }

    /* Scroll view (also the fallback if the flip library fails) */
    var scrollBuilt = false;
    function buildScroll() {
      if (scrollBuilt) return;
      scrollBuilt = true;
      var wrap = document.createElement('div');
      wrap.className = 'abro-fb__scroll';
      pagesEls.forEach(function (p, i) {
        var src = p.querySelector('img');
        var img = document.createElement('img');
        var base = src.dataset.full;
        img.src = base + '&width=1000';
        img.srcset = base + '&width=700 700w, ' + base + '&width=1000 1000w, ' + base + '&width=1392 1392w';
        img.sizes = '(min-width: 900px) 860px, 96vw';
        img.width = 1392; img.height = 1801;
        img.loading = i < 2 ? 'eager' : 'lazy';
        img.alt = src.alt;
        wrap.appendChild(img);
      });
      root.querySelector('.abro-fb__stage').after(wrap);
    }
    function setMode(scroll) {
      if (scroll) buildScroll();
      root.classList.toggle('is-scroll', scroll);
      var btn = root.querySelector('[data-fb="mode"]');
      if (btn) {
        btn.setAttribute('aria-pressed', scroll ? 'true' : 'false');
        btn.querySelector('[data-fb-mode-label]').textContent = scroll ? 'Book view' : 'Scroll view';
      }
      if (!scroll && pageFlip) setTimeout(function () { pageFlip.update(); }, 50);
    }

    /* Zoom viewer */
    var zoomLevel = 1;
    function renderZoom() {
      var h = zoomScroll.clientHeight - 40;
      $all('img', zoomPages).forEach(function (img) { img.style.height = Math.round(h * zoomLevel) + 'px'; img.style.width = 'auto'; });
      zoomLabel.textContent = Math.round(zoomLevel * 100) + '%';
    }
    function openZoom() {
      zoomPages.innerHTML = '';
      visiblePages(current).forEach(function (i) {
        var img = document.createElement('img');
        img.src = imgOf(i).dataset.full + '&width=1392';
        img.alt = imgOf(i).alt;
        img.draggable = false;
        zoomPages.appendChild(img);
      });
      zoomLevel = 1;
      zoomDlg.showModal();
      renderZoom();
    }
    function setZoom(level) {
      var sc = zoomScroll;
      var cx = (sc.scrollLeft + sc.clientWidth / 2) / (sc.scrollWidth || 1);
      var cy = (sc.scrollTop + sc.clientHeight / 2) / (sc.scrollHeight || 1);
      zoomLevel = Math.max(1, Math.min(3, level));
      renderZoom();
      sc.scrollLeft = cx * sc.scrollWidth - sc.clientWidth / 2;
      sc.scrollTop = cy * sc.scrollHeight - sc.clientHeight / 2;
    }
    (function dragToPan() {
      var drag = null;
      zoomScroll.addEventListener('pointerdown', function (e) {
        if (e.pointerType !== 'mouse') return;
        drag = { x: e.clientX, y: e.clientY, l: zoomScroll.scrollLeft, t: zoomScroll.scrollTop };
        zoomScroll.classList.add('is-dragging');
      });
      window.addEventListener('pointermove', function (e) {
        if (!drag) return;
        zoomScroll.scrollLeft = drag.l - (e.clientX - drag.x);
        zoomScroll.scrollTop = drag.t - (e.clientY - drag.y);
      });
      window.addEventListener('pointerup', function () { drag = null; zoomScroll.classList.remove('is-dragging'); });
      zoomScroll.addEventListener('dblclick', function () { setZoom(zoomLevel >= 2 ? 1 : 2); });
      zoomScroll.addEventListener('wheel', function (e) {
        if (!e.ctrlKey) return;
        e.preventDefault();
        setZoom(zoomLevel * (e.deltaY < 0 ? 1.15 : 0.87));
      }, { passive: false });
    })();

    /* Full screen (with a CSS fallback for iPhone Safari, which has no element fullscreen) */
    function toggleFullscreen() {
      var req = shell.requestFullscreen || shell.webkitRequestFullscreen;
      var fsEl = document.fullscreenElement || document.webkitFullscreenElement;
      if (shell.classList.contains('is-pseudo-fs')) { shell.classList.remove('is-pseudo-fs'); document.documentElement.classList.remove('abro-fb-lock'); }
      else if (fsEl) { (document.exitFullscreen || document.webkitExitFullscreen).call(document); }
      else if (req) { req.call(shell); }
      else { shell.classList.add('is-pseudo-fs'); document.documentElement.classList.add('abro-fb-lock'); }
      setTimeout(function () { if (pageFlip) pageFlip.update(); }, 200);
    }
    ['fullscreenchange', 'webkitfullscreenchange'].forEach(function (ev) {
      document.addEventListener(ev, function () { setTimeout(function () { if (pageFlip) pageFlip.update(); }, 150); });
    });

    function share() {
      var url = location.href.split('#')[0];
      var title = document.title;
      if (navigator.share) { navigator.share({ title: title, url: url }).catch(function () {}); return; }
      if (navigator.clipboard) navigator.clipboard.writeText(url).then(function () { showToast('Link copied'); }, function () { showToast(url); });
      else showToast(url);
    }

    /* Wire up controls */
    section.addEventListener('click', function (e) {
      var gotoEl = e.target.closest('[data-fb-goto]');
      if (gotoEl) {
        e.preventDefault();
        var dlg = gotoEl.closest('dialog');
        if (dlg) dlg.close();
        if (!root.contains(gotoEl) || dlg) root.scrollIntoView({ behavior: 'smooth', block: 'start' });
        goTo(parseInt(gotoEl.dataset.fbGoto, 10) - 1);
        return;
      }
      if (e.target.closest('[data-fb-close]')) { e.target.closest('dialog').close(); return; }
      var z = e.target.closest('[data-fb-zoom]');
      if (z) { setZoom(zoomLevel + (z.dataset.fbZoom === 'in' ? 0.5 : -0.5)); return; }
      var btn = e.target.closest('[data-fb]');
      if (!btn) return;
      switch (btn.dataset.fb) {
        case 'prev': userMoved = true; if (pageFlip) pageFlip.flipPrev(); break;
        case 'next': userMoved = true; if (pageFlip) pageFlip.flipNext(); break;
        case 'first': goTo(0); break;
        case 'last': goTo(count - 1); break;
        case 'contents': root.querySelector('#' + root.id + '-contents').showModal(); break;
        case 'thumbs': root.querySelector('#' + root.id + '-thumbs').showModal(); break;
        case 'mode': setMode(!root.classList.contains('is-scroll')); break;
        case 'zoom': openZoom(); break;
        case 'share': share(); break;
        case 'fullscreen': toggleFullscreen(); break;
      }
    });
    $all('dialog').forEach(function (d) {
      d.addEventListener('click', function (e) { if (e.target === d && !d.classList.contains('abro-fb__zoom')) d.close(); });
    });
    input.addEventListener('change', function () {
      var n = parseInt(input.value, 10);
      if (!isNaN(n)) goTo(n - 1);
    });
    input.addEventListener('keydown', function (e) { if (e.key === 'Enter') { e.preventDefault(); input.blur(); input.dispatchEvent(new Event('change')); } });

    document.addEventListener('keydown', function (e) {
      if (!pageFlip || root.classList.contains('is-scroll') || document.querySelector('.abro-fb dialog[open]')) return;
      if (/INPUT|TEXTAREA|SELECT/.test(e.target.tagName) || e.target.isContentEditable) return;
      var r = root.getBoundingClientRect();
      if (r.bottom < 0 || r.top > window.innerHeight) return;
      if (e.key === 'ArrowRight' || e.key === 'PageDown') { e.preventDefault(); userMoved = true; pageFlip.flipNext(); }
      else if (e.key === 'ArrowLeft' || e.key === 'PageUp') { e.preventDefault(); userMoved = true; pageFlip.flipPrev(); }
      else if (e.key === 'Home') { e.preventDefault(); goTo(0); }
      else if (e.key === 'End') { e.preventDefault(); goTo(count - 1); }
    });

    if (window.St && window.St.PageFlip) {
      try { startBook(); } catch (err) { console.error('[flipbook]', err); setMode(true); }
    } else {
      setMode(true);
      var modeBtn = root.querySelector('[data-fb="mode"]');
      if (modeBtn) modeBtn.hidden = true;
    }
  }

  function boot(scope) { Array.prototype.forEach.call((scope || document).querySelectorAll('.abro-fb'), initFlipbook); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { boot(); }); else boot();
  document.addEventListener('shopify:section:load', function (e) { boot(e.target); });
})();
